// extracted by mini-css-extract-plugin
export default {"card":"StatsCard_card__kasNG","title":"StatsCard_title__F7WeL","value":"StatsCard_value__YBq1Y"};